<template>
	<div class="main" v-loading="list_loading">
		<mybread></mybread>
		<el-table :data="healthList" border style="width: 100%">
			<el-table-column prop="id" label="id" width="100"></el-table-column>
			<el-table-column prop="elderName" label="老人姓名"></el-table-column>
			<el-table-column prop="idcardno" label="老人身份证号码"></el-table-column>
			<el-table-column prop="createTime" label="创建时间"></el-table-column>
			<el-table-column prop="type" label="检测类别"></el-table-column>
			<el-table-column prop="time" label="检测时间"></el-table-column>
			<el-table-column prop="result" label="检测结果"></el-table-column>
			<el-table-column prop="collectType" label="来源采集方式"></el-table-column>
			<el-table-column prop="deviceSid" label="设备串号"></el-table-column>
			<el-table-column prop="recordId" label="该类别监测记录唯一标识"></el-table-column>
		</el-table>

		<div class="block">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				background
				@size-change="handleSizeChange"
				:page-sizes="[5, 10, 20]"
				:page-size="pageSize"
				layout="sizes,prev, pager, next,total,jumper"
				:total="total"
			></el-pagination>
			<!-- @size-change="handleSizeChange" sizes, -->
		</div>
	</div>
</template>

<script>
import mybread from '@/components/bread';
export default {
	components: {
		mybread
	},
	inject: ['reload'],
	data() {
		return {
			healthList: [],
			total: 0, //总页数
			pageSize: 10, //每页条数
			currentPage: 1, //当前页（默认第一页）
			list_loading: true//加载
		};
	},
	created() {
		this.getHealthList();
	},
	methods: {
		getHealthList() {
			const data = {
				length: this.pageSize,
				start: (this.currentPage - 1) * this.pageSize
			};
			this.$get('api/showHealthDataList', data)
				.then(res => {
					this.healthList = res.data;
					this.total = res.recordsFiltered;
					this.list_loading=false
					// window.co nsole.log(res)
					this.healthList.map(function(val) {
						switch (
							val.collectType //采集方式
						) {
							case 1:
								val.collectType = 'APP';
								break;
							case 2:
								val.collectType = '微信';
								break;
							case 3:
								val.collectType = '会员网站端';
								break;
						}
						switch (
							val.type //监测类别
						) {
							case 1:
								val.type = '血压';
								break;
							case 2:
								val.type = '血糖';
								break;
							case 3:
								val.type = '体重';
								break;
							case 4:
								val.type = '运动';
								break;
							case 5:
								val.type = '睡眠';
								break;
							case 6:
								val.type = '身体指数';
								break;
							case 7:
								val.type = '血脂';
								break;
							case 8:
								val.type = '血尿酸';
								break;
							case 9:
								val.type = '血氧';
								break;
							case 10:
								val.type = '心电';
								break;
							case 11:
								val.type = '呼吸率';
								break;
							case 12:
								val.type = '精神指数';
								break;
							case 13:
								val.type = '皮肤指数';
								break;
							case 14:
								val.type = '体温';
								break;
							case 15:
								val.type = '健康护理床位';
								break;
						}
					});
				})
				.catch(e => {
					window.console.log(e);
				});
		},

		handleCurrentChange(val) {
			this.currentPage = val; //获取当前页
			this.getHealthList();
			// window.console.log(`当前页: ${val}`);
		},
		handleSizeChange(psize) {
			//选择每页条数
			this.pageSize = psize;
			this.getHealthList();
			// window.console.log(this.pageSize)
		}
	}
};
</script>

<style scoped="scoped">
.block {
	text-align: center;
	margin-top: 20px;
}

.main {
	background: #fff;
	padding: 0 20px 20px 20px;
}
</style>
